import { CashboxScreen } from './CashboxScreen.jsx';

export default {
  path: '/cashbox',
  element: <CashboxScreen />,
  protected: true,
  permission: 'cashbox.view',
  standalone: false,
  sidebar: { label: 'القاصات', icon: 'cashbox', group: 'finance', order: 80 }
};
